<div class="modal-header pt-4">
  <h2 class="modal-title text-center">Código de Seguridad </h2>
</div>


<div class="modal-body pt-2 d-flex flex-column align-items-center">

  <p class="text-center w-100"><span class="bold">VISA, MASTER CARD & OTRAS</span></p>
  <div class="d-flex flex-justify-content-center align-items-center mt-4">
    <picture class="w-50">
      <source srcset="https://www.cubatel.com/images-ads/cdn/assets/cvv/cvv-vmd.webp" type="image/webp">
      <source srcset="https://www.cubatel.com/images-ads/cdn/assets/cvv/cvv-vmd.png" type="image/png">
      <img class="w-100" src="https://www.cubatel.com/images-ads/cdn/assets/cvv/cvv-vmd.png" alt="Reclamar número de teléfono">
    </picture>
    <p class="mb-0 position-relative bottom">Parte posterior de la tarjeta<span class="text-color"><br>Código de 3 dígitos</span></p>
  </div>
  <p class="text-center w-100 mt-4"><span class="bold">AMERICAN EXPRESS</span></p>
  <div class="d-flex flex-justify-content-center align-items-center mb-4">
    <picture class="w-50">
      <source srcset="https://www.cubatel.com/images-ads/cdn/assets/cvv/cvv-ae.webp" type="image/webp">
      <source srcset="https://www.cubatel.com/images-ads/cdn/assets/cvv/cvv-ae.png" type="image/png">
      <img class="w-100" src="https://www.cubatel.com/images-ads/cdn/assets/cvv/cvv-ae.png" alt="Reclamar número de teléfono">
    </picture>
    <p class="mb-0 position-relative top"><span class="text-color">Código de 4 dígitos</span><br>Parte delantera de la tarjeta</p>
  </div>


  <!--<p class="text-center mb-0 pt-4">Esta información nos permite garantizar que la cuenta es legítima y asegurar que la
    tarjeta está en su poder. Esta es una medida de seguridad que ayuda a protegerlo a usted, a Cubatel y a otros
    clientes.</p>-->
</div>
<div class="modal-footer d-flex justify-content-center mb-4">
  <button type="button" class="btn btn-primary banner-button modal-banner-button w-100"
    (click)="activeModal.close()">Cerrar</button>
</div>
